import type { Held as HeldFacts } from './api.js';

/** Only returned figures are facts; an unknown count never becomes a zero. */
export function Held({ held }: { held: HeldFacts | null }) {
  return <>{held?.lines.filter(line => line.count !== null).map(line =>
    <p key={line.kind}>Cobrain already holds {line.count} {line.what} from {line.from}.</p>)}</>;
}
